import { defaultGameCenter, IStyle } from "@flarie/common";


export const getLockTextStyle = (lockTextColor: string) => {
  return {
    lockTextStyle :{
      color: `#${lockTextColor || defaultGameCenter.detail.lockTextColor}`,
    }
  }
}